function getScrollIntersectionType(params) {
  const { y: itemTop, height, scrollY: scrollTop, scrollHeight } = params;
  const scrollBottom = scrollTop + scrollHeight;
  const itemBottom = itemTop + height;
  if (scrollBottom <= itemTop) {
    return "hidden-at-bottom";
  }
  if (scrollTop >= itemBottom) {
    return "hidden-at-top";
  }
  const itemCanBeCompletelyVisible = scrollHeight >= height;
  if (itemCanBeCompletelyVisible) {
    if (scrollBottom > itemTop && scrollBottom < itemBottom) {
      return "partially-visible-at-bottom";
    }
    if (scrollTop > itemTop && scrollTop < itemBottom) {
      return "partially-visible-at-top";
    }
    return "fully-visible";
  }
  if (scrollTop < itemTop && scrollBottom > itemTop) {
    return "partially-visible-at-bottom";
  }
  if (scrollTop < itemBottom && scrollBottom > itemBottom) {
    return "partially-visible-at-top";
  }
  return "partially-visible";
}
export {
  getScrollIntersectionType
};
//# sourceMappingURL=getScrollIntersectionType.js.map
